/* eslint-disable @typescript-eslint/no-empty-function */

import {
  Component,
  forwardRef,
  input,
  signal,
  WritableSignal,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  standalone: true,
  imports: [],
  templateUrl: './textarea.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true,
    },
  ],
})
export class TextareaComponent implements ControlValueAccessor {
  label = input<string>('');
  placeholder = input<string>('');
  disabled: WritableSignal<boolean> = signal(false);
  className = input<string>('');
  readonlyInput = input<boolean>(false);

  value = '';
  onChange: (value: string) => void = () => {};
  onTouched: () => void = () => {};

  get textareaClasses(): string {
    const base =
      'block w-full border border-neutral-700 rounded-md sm:text-sm focus:outline-primary-80 placeholder:text-neutral-700 p-2';
    const disabledClass = this.disabled()
      ? 'opacity-50 cursor-not-allowed'
      : '';
    return `${base} ${disabledClass} ${this.className()}`;
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  onInput(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value;
    this.value = value;
    this.onChange(value);
  }
}
